import { createAction, props } from '@ngrx/store';
import { DialogComponentKey } from '@interfaces/dialog';
import { RootState } from '@store/index';

export namespace RootActions {
  export const rehydrate = createAction('[ROOT] REHYDRATE', props<{ state: RootState }>());

  export const showDialog = createAction('[ROOT] SHOW_DIALOG', props<{ componentKey: DialogComponentKey }>());
  export const showSearchDialog = createAction('[ROOT] SHOW_SEARCH_DIALOG');
  export const showCookieDialog = createAction('[ROOT] SHOW_COOKIE_DIALOG');
  export const showNewsletterDialog = createAction('[ROOT] SHOW_NEWSLETTER_DIALOG');
  export const showWebinarDialog = createAction('[ROOT] SHOW_WEBINAR_DIALOG');

  export const NULL_ACTION = createAction('[NULL ACTION]');
}
